<template>
    <div>
        <div class="qiehuan"  @click="img">
            <img src="@/assets/qiehuan.png" alt="">   
            <span>{{this.title}}</span>
        </div>
        <el-dialog title="班级列表" :visible.sync="shareDialogVisible" width="30%">
            <span>
                <el-radio-group 
                v-model="checkedCities"
                @change="handleCheckedCitiesChange">
                    <el-radio v-for="item in cities" :label="item" :key="item.id">{{item.space_name}}</el-radio>
                </el-radio-group>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="show(1)">取 消</el-button>
                <el-button type="primary" @click="show(2)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import URL from '../../api/index'
export default {
    props:['title'],
    data(){     
        return{
            checkedCities:[],
            shareDialogVisible:false,
            UserInfo:'',
            cities:'',
            spaceid:''
        }
    },
    mounted(){
        this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
        var userspace = {
            token: this.UserInfo.token,
            user_id:this.UserInfo.user_id
        }
        this.$post(URL.userspace, userspace).then(res => {
            var newArray  = []
            var j = 0
            for(var i = 0;i<res.result.length;i++ ){
                if(res.result[i].space_type == '0104'){
                    newArray[j++] = res.result[i]
                }
            }     
            this.cities = newArray
            this.checkedCities = this.cities[0]
            this.spaceid = this.cities[0].space_id
        });
    },
    methods:{
        img(){
            this.shareDialogVisible = true
        },
        handleCheckedCitiesChange(e){
            this.checkedCities=e
            this.spaceid = e.space_id
        },
        show(e){
            var that=this
            if(e == 1){
                that.shareDialogVisible =false
            } else if(e == 2){
                that.shareDialogVisible =false
                this.$emit("spaceid", this.spaceid)
            }
        },
    }
}   
</script>

<style lang="less" scoped>
img{
    width: 20px;
    vertical-align: middle;
    margin-right: 5px;
}
span{
    display: inline-block;
    color: #3c495c;
    font-size: 14px;
}
.qiehuan{
    cursor: pointer;
}
</style>
